import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import M2TLogo from "../common/M2TLogo";

export default function LegalHeader() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="flex w-full items-center justify-between border-b border-gray-700 bg-white px-6 py-4 text-white">
      {/* LEFT SIDE: LOGO + BRAND NAME */}
      <div
        className="flex cursor-pointer items-center gap-2"
        onClick={() => navigate("/")}
        aria-label="Go to homepage"
      >
        <M2TLogo className="h-[1.75rem] sm:h-[2.4rem] md:h-[2.8rem]" />
      </div>

      {/* RIGHT SIDE: COMPANY LINKS 
      <div className="flex items-center space-x-8 text-lg font-medium">
        <button onClick={() => navigate('/about-us')} className={`hover:text-purple-400 ${location.pathname === '/about-us' ? 'text-purple-400' : ''}`}>About Us</button>
        <button onClick={() => navigate('/team')} className={`hover:text-purple-400 ${location.pathname === '/team' ? 'text-purple-400' : ''}`}>Team</button>
        <button onClick={() => navigate('/careers')} className={`hover:text-purple-400 ${location.pathname === '/careers' ? 'text-purple-400' : ''}`}>Careers</button>
        <button onClick={() => navigate('/vision-mission')} className={`hover:text-purple-400 ${location.pathname === '/vision-mission' ? 'text-purple-400' : ''}`}>
          Mission & Vision
        </button>
      </div>
      */}
    </header>
  );
}
